import script from "./cameraDataScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./cameraDataScreen.vue?vue&type=script&setup=true&lang=js"

import "./cameraDataScreen.vue?vue&type=style&index=0&id=3047bc82&lang=scss&scoped=true"

import exportComponent from "F:\\tubida\\tbd_screen_client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3047bc82"]])

export default __exports__